export class InvalidFileNameError extends Error {
  constructor(message) {
    super(message);
    this.name = 'InvalidFileNameError';
  }
}
